import { forwardRef } from 'react';

import { Button } from '..';
import { TProps } from '../types/TProps';

export const BoldButton = forwardRef<HTMLButtonElement, TProps>(({ className, ...props }, ref) => (
  <Button ref={ref} className={['btn--bold', className].filter(Boolean).join(' ')} {...props} />
));

BoldButton.displayName = 'BoldButton';
